import { forwardRef } from 'react';

import { useField, useForwardingRef } from '@adflow/frontend/util-common';

import type { FormControlProps } from '../FormControl';
import { FormControl } from '../FormControl';

import type { TextareaProps } from './Textarea';
import { Textarea } from './Textarea';

export type TextareaWithControlProps = {
	name: string;
	context?: Record<string, unknown>;
	autoCompleteOff?: boolean;
	forcedErrorMessage?: string;
} & FormControlProps &
	TextareaProps;

export const TextareaWithControl = forwardRef<
	HTMLTextAreaElement,
	TextareaWithControlProps
>(function TextareaWithControlRender(
	{
		name,
		defaultValue,
		context,
		forcedErrorMessage,
		label,
		labelStyle,
		outerStyle,
		helperStyle,
		helperText,
		...other
	},
	forwardedRef
) {
	const {
		field: { value, ref: fieldRef, ...restField },
		fieldState: { invalid },
		errorMessage,
	} = useField({ name, defaultValue, ...context });

	const ref = useForwardingRef(null, [forwardedRef, fieldRef]);

	return (
		<FormControl
			label={label}
			labelStyle={labelStyle}
			helperText={forcedErrorMessage || errorMessage || helperText}
			helperStyle={helperStyle}
			error={forcedErrorMessage ? true : invalid}
			outerStyle={outerStyle}
		>
			<Textarea
				ref={ref}
				error={forcedErrorMessage ? true : invalid}
				{...other}
				{...restField}
				value={value ?? ''}
			/>
		</FormControl>
	);
});
